export default __webpack_public_path__ + "static/media/myjourney-greentree-empty.21a744c4.svg";